import React from 'react';
import { motion } from 'framer-motion';
import { MapPin, Clock, ChevronRight } from 'lucide-react';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import L from 'leaflet';

// Custom yellow marker
const yellowIcon = new L.Icon({
  iconUrl: 'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-gold.png',
  shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png',
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41]
});

const LocationSection = () => {
  return (
    <section id="posizione" className="py-24 md:py-32 px-6 md:px-12 lg:px-24 bg-[#0A0A0A]">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Text Content */}
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
          >
            <span className="text-[#FFCC00] text-xs sm:text-sm font-semibold tracking-[0.2em] uppercase mb-4 block">
              Dove Siamo
            </span>
            <h2 className="font-heading text-3xl sm:text-4xl md:text-5xl font-bold text-white mb-6">
              Nel cuore di
              <br />
              <span className="text-[#FFCC00]">Napoli</span>
            </h2>
            <p className="text-gray-400 text-lg mb-8">
              A pochi passi dalla Stazione Centrale e dal centro storico. 
              Facilmente raggiungibile con metro, bus e a piedi.
            </p>

            <div className="space-y-4 mb-8">
              <div className="flex items-start gap-4">
                <MapPin className="w-6 h-6 text-[#FFCC00] flex-shrink-0 mt-1" />
                <div>
                  <p className="text-white font-semibold">Indirizzo</p>
                  <p className="text-gray-400">Via Ernesto Capocci 6, 80133 Napoli</p>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <Clock className="w-6 h-6 text-[#FFCC00] flex-shrink-0 mt-1" />
                <div>
                  <p className="text-white font-semibold">Orari</p>
                  <p className="text-gray-400">Tutti i giorni: 6:00 - 23:00</p>
                </div>
              </div>
            </div>

            <a
              href="https://maps.google.com/?q=Via+Ernesto+Capocci+6+Napoli+80133"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="directions-cta"
              className="inline-flex items-center gap-2 text-[#FFCC00] font-semibold hover:underline"
            >
              Ottieni indicazioni
              <ChevronRight className="w-5 h-5" />
            </a>
          </motion.div>

          {/* Map */}
          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            className="h-[400px] lg:h-[500px] border border-[#2A2A2A]"
          >
            <MapContainer
              center={[40.8518, 14.2681]}
              zoom={16}
              style={{ height: '100%', width: '100%' }}
              scrollWheelZoom={false}
            >
              <TileLayer
                url="https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}{r}.png"
                attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
              />
              <Marker position={[40.8518, 14.2681]} icon={yellowIcon}>
                <Popup>
                  <div className="text-center">
                    <strong>Unlock Bags</strong><br />
                    Via Ernesto Capocci 6<br />
                    80133 Napoli
                  </div>
                </Popup>
              </Marker>
            </MapContainer>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default LocationSection;
